module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/biomass-boiler-housing-4b665b05ada1d14441d62ada550f622a.png";